<template>
  <!-- 一部电影 -->
    <div class="movie-item">
    <div v-on:mouseover="handleHover(true)" v-on:mouseleave="handleHover(false)">
      <!-- 海报 -->
      <router-link :to="movieInfoUrl" class="poster-link">
        <div class="poster-frame">
          <img class="poster" :src="this.global.base + normalizedMovie.moviePoster">
        </div>
      </router-link>
      <!-- 鼠标划过时的效果 -->
      <div class="movie-item-hover" v-if="isHover && !$platform.isMobile">
        <!-- 海报 -->
        <router-link :to="movieInfoUrl">
          <img class="poster-hover" :src="this.global.base + normalizedMovie.moviePoster">
          <!-- 鼠标划过时显示的信息 -->
          <div class="movie-hover-info">
            <div class="title-hover">
              <span class="name-tags">{{normalizedMovie.movieName}}</span>
            </div>
            <div class="title-hover">
              <span class="name-tags">类型: </span>{{normalizedMovie.movieCategoryText}}
            </div>
            <div class="title-hover">
              <span class="name-tags">上映时间: </span>{{normalizedMovie.releaseDate}}
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <!-- 标题 -->
    <div class="title-style">
      <router-link :to="movieInfoUrl">{{normalizedMovie.movieName}}</router-link>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: "movie-item",
  props: {
    movieItem: Object
  },
  data() {
    return {
      isHover: false
    }
  },
  computed: {
    normalizedMovie() {
      const movieItem = this.movieItem || {}
      const posterList = this.toArrayValue(movieItem.moviePoster)
      const categoryList = this.toArrayValue(movieItem.movieCategoryList)
      return {
        movieId: movieItem.movieId,
        movieName: movieItem.movieName || '',
        moviePoster: posterList[0] || '',
        moviePictures: this.toArrayValue(movieItem.moviePictures),
        releaseDate: movieItem.releaseDate
          ? moment(movieItem.releaseDate).format('YYYY-MM-DD')
          : '',
        movieCategoryText: categoryList.map((item) => {
          return item && item.movieCategoryName ? item.movieCategoryName : item
        }).filter(Boolean).join('/'),
      }
    },
    movieInfoUrl() {
      return '/movieInfo/' + (this.normalizedMovie.movieId || '')
    }
  },
  methods: {
    toArrayValue(value) {
      if (Array.isArray(value)) {
        return value
      }
      if (value === null || value === undefined || value === '') {
        return []
      }
      if (typeof value === 'string') {
        const parsedValue = this.safeParse(value)
        if (Array.isArray(parsedValue)) {
          return parsedValue
        }
        return parsedValue === value ? [value] : []
      }
      return []
    },
    safeParse(value) {
      try {
        return JSON.parse(value)
      } catch (error) {
        return value
      }
    },
    handleHover(nextState) {
      if (this.$platform.isMobile) {
        this.isHover = false
        return
      }
      this.isHover = nextState
    }
  }
}
</script>

<style scoped>
.movie-item{
  margin-top: 30px;
  margin-left: 30px;
  display: inline-block;
  vertical-align: top;
  position: relative;
}

.poster-link{
  display: block;
}

.poster-frame{
  width: 160px;
  aspect-ratio: 8 / 11;
  overflow: hidden;
}

.poster{
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.title-style{
  width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  font-size: 16px;
  color: #333;
  margin-top: 10px;
}

.score{
  color: #ffb400;
  font-size: 24px;
  font-style: italic;
}

a{
  text-decoration: none;
  color: #333;
}

.movie-item-hover{
  position: absolute;
  width: 218px;
  height: 300px;
  z-index: 10;
  top: -40px;
  left: -29px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 0 16px #fff, 0 0 6px rgba(0,0,0,.2);
}

.poster-hover{
  width: 218px;
  height: 300px;
}

.movie-hover-info{
  padding: 16px;
  height: 150px;
  box-sizing: border-box;
  position: absolute;
  z-index: 11;
  top: 150px;
  background: #fff;
  width: 218px;
  color: #999;
}

.title-hover:first-child{
  font-size: 20px;
  line-height: 20px;
  margin-top: 6px;
}

.title-hover{
  font-size: 16px;
  line-height: 16px;
  margin-top: 12px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.name-tags{
  color: #333;
}

@media (max-width: 1023px) {
  .movie-item {
    margin-left: 20px;
  }
}

@media (max-width: 768px) {
  #app.is-mobile-layout .movie-item {
    width: calc(50% - 8px);
    margin: 0;
  }

  #app.is-mobile-layout .movie-item .poster-frame,
  #app.is-mobile-layout .movie-item .title-style {
    width: 100%;
  }

  #app.is-mobile-layout .movie-item-hover {
    display: none;
  }
}

</style>
